<div class="mx-auto max-w-[350px] rounded-2xl ring-1 ring-white/10 bg-turquoise/10 card-hover-effect">
    <div class="p-6">
        <div class="flex items-center gap-x-4">
            <div>
                <img src="https://imgix.cosmicjs.com/f7c98b80-6612-11ef-80bb-ff60e40f80b5-Dimers-Platinum-Icon---Highlights.png?auto=format,compress&w=100"
                    alt="Dimers Platinum icon" width="28" height="28" loading="lazy">
            </div>
            <div class="text-lg md:text-2xl font-bold text-white ">
                CFB 2025 AI Picks
            </div>
        </div>

        <div class="mt-4 flex justify-between items-center">
            <app-countdown-timer [isCard]="true"></app-countdown-timer>
            <div class="inline-flex items-center rounded-md bg-green-500/10 px-2 py-1 text-sm font-medium text-green-400 ring-1 ring-inset ring-green-500/20">
                Launch Price
            </div>
        </div>
        <div class="mt-4 flex items-baseline gap-x-2">
            <span class="text-3xl font-bold text-gray-500 line-through">$349</span>
            <span class="text-4xl font-bold tracking-tight text-white">$279</span>
            <span class="text-base sm:text-2xl font-medium text-green-400">(save $70)</span>
        </div>
        <p class="mt-2 text-base text-white font-semibold">Full season, billed once</p>

        <div class="my-4 h-px w-full bg-white/10"></div>

        <ul role="list" class="space-y-2 text-base leading-6 text-white">
            <li class="flex gap-x-3">
                <img src="https://imgix.cosmicjs.com/02950b30-589c-11f0-ae5a-0f56aa053fcd-check-1.svg" alt="check icon"
                    width="24" height="24" loading="lazy">
                Weekly pick drops
            </li>
            <li class="flex gap-x-3">
                <img src="https://imgix.cosmicjs.com/02950b30-589c-11f0-ae5a-0f56aa053fcd-check-1.svg" alt="check icon"
                    width="24" height="24" loading="lazy">
                Best available odds
            </li>
            <li class="flex gap-x-3">
                <img src="https://imgix.cosmicjs.com/02950b30-589c-11f0-ae5a-0f56aa053fcd-check-1.svg" alt="check icon"
                    width="24" height="24" loading="lazy">
                Members-only access
            </li>
            <li class="flex gap-x-3">
                <img src="https://imgix.cosmicjs.com/02950b30-589c-11f0-ae5a-0f56aa053fcd-check-1.svg" alt="check icon"
                    width="24" height="24" loading="lazy">
                Proven track record
            </li>
        </ul>

        <a href="https://pay.dimers.com/b/cNi8wPe0geFngqn5n6gfu05" target="_blank" rel="noopener noreferrer"
            class="mt-4 block w-full rounded-md bg-turquoise px-3 py-3 text-center text-base font-semibold text-black shadow-sm hover:bg-cyan-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan-400">
            Get AI Picks
        </a>

        <div class="mt-4 flex flex-col items-center justify-center gap-2 text-sm text-white">
            <div class="flex items-center gap-2">
                <img src="https://imgix.cosmicjs.com/bcc603f0-5af0-11f0-a4fe-b183d1486c9b-shield-check-greeen.svg" alt="icon" width="20" height="20" loading="lazy">
                Guaranteed safe & secure checkout 
            </div>
            <div>
                <img src="https://imgix.cosmicjs.com/c6be3de0-5af1-11f0-a4fe-b183d1486c9b-0209bc90-aac0-11ef-9da2-d1ed2e62fff4-Powered-by-Stripe-white.svg?auto=format,compress&amp;w=300" width="150" height="20" alt="stripe" loading="lazy">
            </div>
        </div>
    </div>
</div>